/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';
import { Fade } from 'react-awesome-reveal';

import HomeImg from '../../assets/images/florai/home.png';
import CareImg from '../../assets/images/florai/care.png';
import IssuesImg from '../../assets/images/florai/issues.png';
import FloraiSectionBackdrop from './FloraiSectionBackdrop';

const screens = [
  {
    img: HomeImg,
    alt: 'Home screen with trending plants and know-how',
    title: 'Discover & learn',
    caption: 'Trending species, plant know-how, and growing guides for your region.',
  },
  {
    img: CareImg,
    alt: 'Care tab with water calculator, sunlight and soil',
    title: 'Care that fits your plant',
    caption: 'Water calculator, sunlight, soil, and how-tos — from repotting to propagation.',
  },
  {
    img: IssuesImg,
    alt: 'Health check screen with common problems',
    title: 'Health checks',
    caption: 'Spot common problems early and get a treatment plan in three questions.',
  },
];

// "Inside the app" — three real app screens in phone frames
export default function FloraiShowcase() {
  return (
    <section id="florai-inside" className="florai px-4 !mb-4">
      <div className="relative rounded-[32px] overflow-hidden max-w-[1400px] mx-auto py-16 px-4">
        <FloraiSectionBackdrop overlayClass="bg-[#FAFCF7]/[.9]" positionClass="object-bottom" />
        <div className="relative z-10 max-w-[1120px] mx-auto">
        <Fade direction="up" triggerOnce>
          <p className="text-[.74rem] font-bold tracking-[.16em] uppercase text-[#3E6B2A] mb-3">Inside the app</p>
          <h2 className="text-[clamp(1.9rem,3.8vw,2.8rem)] leading-tight mb-3.5 tracking-tight !font-semibold text-[#24361B]">
            More than
            {' '}
            <em className="font-instrument-serif !font-normal text-[1.08em]">identification</em>
          </h2>
          <p className="text-[#4A5C42] max-w-2xl mb-12 text-[1.05rem]">
            Real screens from the app — discovery, daily care, and health checks for every plant
            you save.
          </p>
        </Fade>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          {screens.map((s, i) => (
            <Fade key={s.title} direction="up" delay={i * 120} triggerOnce className="h-full">
              <figure className="m-0 h-full bg-[#EEF2EC] rounded-3xl p-5 flex flex-col gap-4 items-center">
                <div className="w-full max-w-[240px] rounded-[32px] bg-[#0D1A11] border-[7px] border-[#1C2618] shadow-[0_24px_48px_rgba(36,54,27,.22)] overflow-hidden aspect-[9/19.4]">
                  <img src={s.img} alt={s.alt} loading="lazy" className="w-full h-full object-cover object-top" />
                </div>
                <figcaption className="text-center">
                  <b className="block text-[1.02rem] font-bold text-[#24361B]">{s.title}</b>
                  <span className="text-[.86rem] text-[#5C6B53]">{s.caption}</span>
                </figcaption>
              </figure>
            </Fade>
          ))}
          </div>
        </div>
      </div>
    </section>
  );
}
